/**
 * Labstep
 *
 * @module components/ResourceItem/Action/Create
 * @desc Create Action for resource item
 */

import { getFieldsResourceItemCreateForm } from 'labstep-web/components/ResourceItem/Form/fields';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { FormCreateContainer as FormCreate } from 'labstep-web/core/Form/Create';
import type { IFormCreateContainerProps } from 'labstep-web/core/Form/Create/types';
import { ResourceItem } from 'labstep-web/models/resource-item.model';
import type React from 'react';
import type { IResourceItemFormCreateProps } from './types';

export const ResourceItemFormCreate: React.FC<
  IResourceItemFormCreateProps
> = ({
  resource,
  options,
  activeGroup,
  resourceTemplate,
  protocolValueOrigin,
  protocolValueOriginBody,
}) => {
  const defaultValues: IFormCreateContainerProps['defaultValues'] =
    {};
  if (resource) {
    defaultValues.resource = resource;
  }
  const body: IFormCreateContainerProps['body'] = {};
  if (protocolValueOriginBody) {
    body.protocol_value_origin = protocolValueOriginBody;
  }
  if (protocolValueOrigin) {
    body.protocol_value_origin_guid = protocolValueOrigin.guid;
    body.amount = protocolValueOrigin.amount;
    body.unit = protocolValueOrigin.unit;
  }

  return (
    <FormCreate
      entityName={ResourceItem.entityName}
      autoFocus={!resource}
      defaultValues={defaultValues}
      options={options}
      fields={getFieldsResourceItemCreateForm({
        groupId: activeGroup?.id,
        resourceTemplate,
        protocolValueOriginGuid: protocolValueOrigin?.guid,
      })}
      body={body}
    />
  );
};

export default withActiveGroup(ResourceItemFormCreate);
